import { render, staticRenderFns } from "./EspaceAcquereur.vue?vue&type=template&id=7aa747ba&"
import script from "./EspaceAcquereur.vue?vue&type=script&lang=js&"
export * from "./EspaceAcquereur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports